import axios from "axios";

export const http = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
    // headers: `Bearer ${localStorage.getItem("access_token")}` as any
});

http.interceptors.request.use((req) => {
    const token = localStorage.getItem("access_token");
    if (token) {
        req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
});

// Add a response interceptor
http.interceptors.response.use(
    response => {
        return response;
    },
    async error => {
        if (error.response) {
            // Check if the status code is 401 (Unauthorized)
            if (error.response.status === 401) {
                try {
                    // Refresh the access token
                    const newToken = await refreshAccessToken();
                    // Retry the failed request with the new token
                    const config = error.config;
                    config.headers.Authorization = `Bearer ${newToken}`;
                    return axios(config);
                } catch (refreshError) {
                    localStorage.clear();
                    window.location.href = '/login'
                    return Promise.reject(refreshError);
                }
            }
        }
        return Promise.reject(error);
    }
);



const refreshAccessToken = async () => {
    try {
        const tokenRefreshEndpoint = `${process.env.REACT_APP_API_ENDPOINT}v1/user/refresh_token`;
        const refreshToken = localStorage?.getItem("refresh_token")
        if (refreshToken) {
            const response = await axios.post(tokenRefreshEndpoint, {
                refresh_token: refreshToken,
                user_id: localStorage.getItem("user_id")
            });
            if (response?.data?.error) {
                throw response?.data?.error
            }
            const newToken = response.data.access_token;
            const refresh_token = response.data.refresh_token;
            localStorage.setItem('access_token', newToken);
            localStorage.setItem('refresh_token', refresh_token);
            return newToken;
        }

    } catch (error) {
        throw error;
    }
};